// ranking-reveal 编辑器：条目 name/desc/color + 增删（rank=index+1）。
import { useTranslation } from 'react-i18next'
import type { EditorContext } from '../_shared/types'
import type { RankingData } from './types'
import { Field, TextInput, ColorField, Repeater, RemoveButton } from '../../components/editor-controls'

export function RankingRevealEditor({ data, update }: EditorContext) {
  const { t } = useTranslation()
  const d = data as unknown as RankingData
  const items = d.items || []
  return (
    <>
      <Field label={t('editor.title')}>
        <TextInput value={d.title ?? ''} onChange={(v) => update((dd) => { dd.title = v })} />
      </Field>
      <Field label={t('editor.itemsCount', { count: items.length })}>
        {items.map((it, i) => (
          <div className="editable-item col" key={i}>
            <div className="editable-item">
              <span className="ei-rank">#{i + 1}</span>
              <TextInput
                value={it.name}
                placeholder={t('editor.namePh')}
                style={{ flex: 1 }}
                onChange={(v) => update((dd) => { dd.items[i].name = v })}
              />
              <RemoveButton onRemove={() => update((dd) => { dd.items.splice(i, 1) })} />
            </div>
            <TextInput
              value={it.desc}
              placeholder={t('editor.descPh')}
              onChange={(v) => update((dd) => { dd.items[i].desc = v })}
            />
            <ColorField value={it.color} onChange={(c) => update((dd) => { dd.items[i].color = c })} />
          </div>
        ))}
        <Repeater
          addLabel={t('editor.items')}
          onAdd={() =>
            update((dd) => {
              dd.items.push({ rank: items.length + 1, name: '', desc: '', color: '#6366f1' })
            })
          }
        />
      </Field>
    </>
  )
}
